export default __webpack_public_path__ + "static/media/car.9ad1b810.jpg";